export default "__VITE_ASSET__BK9gjbe6__"